/**
 * LandingPage — public marketing entry point for unauthenticated visitors.
 *
 * MarketingShell owns the URL-backed bilingual public site and local demos.
 * Swedish and English share the same page structure with locale-specific URLs.
 * The marketing experience does not change the inspection application's theme.
 *
 * The previous single-page implementation is archived as
 * `LandingPage.legacy.tsx` for reference and is not imported anywhere.
 *
 * The prop shape (`{ onLogin }`) is intentionally preserved so App.tsx
 * does not need to change.
 */
import React from 'react';
import { MarketingShell } from './marketing/MarketingShell';

interface LandingPageProps {
  onLogin: () => void;
}

const LandingPage: React.FC<LandingPageProps> = ({ onLogin }) => (
  <MarketingShell onLogin={onLogin} />
);

export default LandingPage;
